import base64 from '@/common/global/base64.js';

//获取页面实例
const fSmGetPrePage = (pageNo = 2) => {
	let pages = getCurrentPages();
	// console.log(pages)
	let prePage = pages[pages.length - pageNo];
	// #ifdef H5
	return prePage;
	// #endif
	return prePage.vm;
}

//获取url参数
const fSmGetUrlParam = (name, deBase64 = false) => {
	name = name.replace(/[]/, "\[").replace(/[]/, "\[").replace(/[]/, "\\\]");
	var regexS = "[\\?&]" + name + "=([^&#]*)";
	var regex = new RegExp(regexS);
	var results = regex.exec(window.parent.location.href);
	if (results == null) return "";
	else {
		if (deBase64) {
			return Base64.encode(results[1]);
		}
		return results[1];
	}
};

//组装树结构
const fTranListToTreeData = (list) => {
  // 1. 定义两个中间变量
  const treeList = [], // 最终要产出的树状数据的数组
    map = {} // 存储映射关系
  // 2. 建立一个映射关系，并给每个元素补充children属性.
  // 映射关系: 目的是让我们能通过id快速找到对应的元素
  // 补充children：让后边的计算更方便
  list.forEach(item => {
    item.children = []
    map[item.comp_name] = item
  })
  // 3. 循环
  list.forEach(item => {
    // 对于每一个元素来说，先找它的上级
    //    如果能找到，说明它有上级，则要把它添加到上级的children中去
    //    如果找不到，说明它没有上级，直接添加到 treeList
    let parent = map[item.p_org_comp_name]
    if (parent ) {
      if (item.comp_name != item.p_org_comp_name) {
        parent.children.push(item)
      }
    } else {
      treeList.push(item)
    }
  })
  // 4. 返回出去
  return treeList
}

//获取固定长度随机码
const fSmGetFixLenRomStr = (strLen, strType = 'num') => {
	var resStr = "";
	var romLen = 10;
	if (strType == 'num') {
		var selectChar = new Array(0, 1, 2, 3, 4, 5, 6, 7, 8, 9);
	} else {
		var selectChar = new Array(0, 1, 2, 3, 4, 5, 6, 7, 8, 9, "A", "B", "C", "D", "E", "F", "G", "H",
			"I",
			"G", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z");
		romLen = 32;
	}

	for (let i = 0; i < strLen; i++) {
		let charIndex = Math.floor(Math.random() * romLen);
		resStr += selectChar[charIndex];
	}
	if (resStr.length != strLen) {
		fGetFixLenRomStr(strLen);
	}
	return resStr;
}

// 压缩图片
const fSmCompressImg = file => {
	return new Promise((resolve, reject) => {
		let reader = new FileReader();
		reader.onloadend = function (e) {
			let img = new Image();
			img.onload = function () {
				let canvasWidth = img.width; // 图片原始长宽
				let canvasHeight = img.height;
				let canvas = document.createElement('canvas');
				let ctx = canvas.getContext('2d');
				// 创建固定750宽度的图片，可自定义大小
				canvas.width = 800;
				canvas.height = (800 * canvasHeight) / canvasWidth;
				ctx.drawImage(img, 0, 0, 800, (800 * canvasHeight) / canvasWidth);
				canvas.toBlob(
					function (blob) {
						// 创建file文件
						let pressFile = new File([blob], file.name, {
							type: file.type
						});
						Object.defineProperty(pressFile, 'path', {
							get: () => URL.createObjectURL(blob)
						});
						return resolve(pressFile);
					},
					file.type,
					1 // 图片质量，值0-1之间，可不填默
				);
			};
			img.src = e.target.result;
		};
		// 读取 File 对象，然后触发 loadend 事件
		reader.readAsDataURL(file);
	});
}

//判断是否在微信中
const fSmIsWechat = () => {
	var ua = window.navigator.userAgent.toLowerCase();
	if (ua.match(/micromessenger/i) == 'micromessenger') {
		// console.log('是微信客户端')
		return true;
	} else {
		// console.log('不是微信客户端')
		return false;
	}
}

const fSmIsAli = () => {
	var ua = window.navigator.userAgent.toLowerCase();
	if (ua.match(/Alipay/i) == "alipay") {
		// console.log('是支付宝客户端')
		return true;
	} else {
		// console.log('不是支付宝客户端')
		return false;
	}
}

//base64加密
const fSmUtf8ToBase64 = (str) => {
	return window.btoa(unescape(encodeURIComponent(str)));
}

const fSmPayParams = (userPhone, mallId, djType, djDhId, payDesc, payMoney) => {
	userPhone = fSmUtf8ToBase64(userPhone);
	mallId = fSmUtf8ToBase64(mallId);
	djType = fSmUtf8ToBase64(djType);
	djDhId = fSmUtf8ToBase64(djDhId);
	payDesc = fSmUtf8ToBase64(payDesc);
	payMoney = fSmUtf8ToBase64(payMoney);


	let param = 'userPhone=' + userPhone + '&mallId=' + mallId + '&djType=' + djType +
		'&djDhId=' + djDhId + '&payDesc=' + payDesc + '&payMoney=' + payMoney;
	param.replace(/%/g, '%25');
	return param;
}

//判断字符是否为空
const fSmIsEmpty = (value) => {

  return (
    value === null || value === undefined ||
    (typeof value === 'object' && Object.keys(value).length === 0) ||
    (typeof value === 'string' && value.trim().length === 0)
  )


}



export default {
	fSmGetPrePage, //获取页面实例
	fSmGetUrlParam, //获取url参数
	fSmCompressImg, // 图片上传
	fSmGetFixLenRomStr, //获取固定长度随机码
	fSmIsWechat,//微信浏览器
	fSmIsAli,//支付宝浏览器
	fSmPayParams, // 支付参数组装
	fSmUtf8ToBase64, // url base64 加密
	fSmIsEmpty, //判断字符是否为空
  fTranListToTreeData
}



// WEBPACK FOOTER //
// ./src/common/global/smCom.js